import { render, staticRenderFns } from "./ChatAnnualCharge.vue?vue&type=template&id=52d976d1"
import script from "./ChatAnnualCharge.vue?vue&type=script&lang=js"
export * from "./ChatAnnualCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports